import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import editIconActive from '../../../images/insight360/edit-icon_active.png';
import infoIconWhite from '../../../images/insight360/info-icon_white.png';
import clearFilterIcon from '../../../images/insight360/clear-field-icon_white.png';
import {
  WEIGHTED_LABEL,
  REACH_LABEL,
  INSIGHT_360_CREATOR_VARIANCE_INFO,
  PERSONA_CREATOR_DEF_LENGTH,
  LENGHTOF_PDF_LABEL,
  SAMPLE_LABEL,
} from '../../../constants';
import {
  WEIGHTED_INFO_MSG,
  REACH_INFO_MSG,
  PERSONA_CREATOR_DEF_LENGTH_WARNING,
  SAMPLE_INFO_MSG,
} from '../../../messages/messages';
import { numberWithCommas, nthOccurrence } from '../../../util/CommonUtils';
import Modal from '../../common/Modal/Modal';
import GenericButton from '../../common/GenericButton';
import InlineEdit from '../../common/InlineEdit/InlineEdit';

const modalWariningStyle = {
  width: '30%',
  height: '40px',
  left: '35%',
  top: '25%',
};

class PersonaCreatorHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      PersonaCreatorheaderInfo:
        this.props.pcheaderData !== undefined ? this.props.pcheaderData : [],
      PersonaCreatorheaderVariance:
        this.props.segments !== undefined &&
          this.props.segments.variance !== undefined
          ? this.calculateVariance(this.props.segments.variance)
          : '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.pcheaderData !== undefined) {
      this.setState({ PersonaCreatorheaderInfo: nextProps.pcheaderData });
    }

    if (!nextProps.segments) {
      this.setState({ PersonaCreatorheaderVariance: null });
    } else if (this.props.segments !== nextProps.segments) {
      this.setState({
        PersonaCreatorheaderVariance: this.calculateVariance(
          nextProps.segments.variance,
        ),
      });
    }
  }

  getIndexOfPdfLabel = () => {
    let lenghtOfPdfLabel = LENGHTOF_PDF_LABEL;
    const nthOccurrenceIndex = nthOccurrence(
      this.props.pcheaderData.label,
      ')',
      2,
    );
    if (
      nthOccurrenceIndex < lenghtOfPdfLabel &&
      nthOccurrenceIndex !== -1 &&
      nthOccurrenceIndex !== 'undefined'
    ) {
      lenghtOfPdfLabel = nthOccurrenceIndex + 1;
    }
    return lenghtOfPdfLabel;
  };

  personaHeaderLabelValidate = (value, callback) => {
    // check the label max length equal to 64
    let callBackArg;
    if (value.length > PERSONA_CREATOR_DEF_LENGTH) {
      callBackArg = false;
    } else {
      callBackArg = true;
    }
    callback(
      callBackArg,
      callBackArg ? '' : PERSONA_CREATOR_DEF_LENGTH_WARNING,
    );
  };

  personaHeaderLabelUpdate = (value, callback) => {
    const labelUpdateParams = {
      defId: this.props.segments.defId,
      defName: value,
      segments: this.props.segments.segments,
      productId: this.props.insight360study.productId,
    };
    this.props.savePersonaCreatorDefLabel(labelUpdateParams, callback);
  };

  handleRemovePersonaCreatorClick() {
    this.modalWarining.show();
  }

  removePersonaCreatorOk = () => {
    this.props.removePersonaCreator();
  };

  calculateVariance = PersonaCreatorheaderVariance => {
    if (
      PersonaCreatorheaderVariance === undefined ||
      PersonaCreatorheaderVariance === null ||
      PersonaCreatorheaderVariance === ''
    ) {
      return '';
    }
    return Math.round(PersonaCreatorheaderVariance * 1000) / 10;
  }

  render() {
    return (
      <div className="row expanded" id="personaCreatorHeader">
        <Modal
          title=""
          ref={node => (this.modalWarining = node)}
          dialogStyles={modalWariningStyle}
        >
          <div className="text-center">
            <p>This is going to delete Persona Creator</p>
            <GenericButton
              name="Ok"
              btnStyle="button btn-cncl button-125px"
              onBtnClick={() => {
                this.removePersonaCreatorOk();
                this.modalWarining.hide();
              }}
            />
          </div>
        </Modal>
        <div className="">
          {this.props.pcheaderData !== undefined && (
            <div id="pdfCreatorHeader">
              <div className="row fullwidth demographic-header-border demographic-detail-columns relative-position">
                <div className="large-6 medium-6 small-6 columns creatorHeaderLabelFlag ">
                  <div className="demographic-float small-12">
                    <div className="div-overflow ">
                      <div className="persona-info xtra-padding">
                        <InlineEdit
                          textVal={this.props.pcheaderData.label}
                          editBlockWidth="100%"
                          icon={editIconActive}
                          updateFn={this.personaHeaderLabelUpdate}
                          validateFn={this.personaHeaderLabelValidate}
                          labelClass="personaHeaderLabel"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="large-6 medium-6 small-6 columns pdfCreatorheaderLabelFlag">
                  <div className="div-overflow">
                    <div className="creator_pdf_inline_edit_label">
                      <span>
                        {this.props.pcheaderData.label.substring(
                          0,
                          this.getIndexOfPdfLabel(),
                        )}
                      </span>
                      <br />
                      <span>&nbsp;</span>
                      <br />
                      <span className="pdfCreatorVariance">
                        PERCENTAGE VARIANCE EXPLAINED{' '}
                        {this.state.PersonaCreatorheaderVariance == null
                          ? ''
                          : ` ${this.state.PersonaCreatorheaderVariance} %`}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="large-2 medium-2 small-2 columns text-align-center">
                  <div className="demographic-float-none">
                    <div className="div-overflow">
                      <div className="weight-reach-info">
                        {SAMPLE_LABEL}
                        <img
                          className="i360_header_icons_img"
                          src={infoIconWhite}
                          alt={SAMPLE_INFO_MSG}
                          title={SAMPLE_INFO_MSG}
                        />
                      </div>
                      <div className="weight-reach-data">
                        {numberWithCommas(
                          Math.round(this.props.pcheaderData.sample),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="large-2 medium-2 small-2 columns">
                  <div className="demographic-float">
                    <div className="div-overflow">
                      <div className="weight-reach-info">
                        {WEIGHTED_LABEL}
                        <img
                          className="i360_header_icons_img"
                          src={infoIconWhite}
                          alt={WEIGHTED_INFO_MSG}
                          title={WEIGHTED_INFO_MSG}
                        />
                      </div>
                      <div className="weight-reach-data">
                        {numberWithCommas(
                          Math.round(this.props.pcheaderData.weighted),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="large-2 medium-2 small-2 columns">
                  <div className="demographic-float">
                    <div className="div-overflow">
                      <div
                        className="weight-reach-info"
                        id="weight-reach-data-pdf"
                      >
                        {REACH_LABEL}
                        <img
                          className="i360_header_icons_img"
                          src={infoIconWhite}
                          alt={REACH_INFO_MSG}
                          title={REACH_INFO_MSG}
                        />
                      </div>
                      <div className="weight-reach-data">
                        {Math.round(this.props.pcheaderData.pct * 10) / 10}%
                      </div>
                    </div>
                    <div className="div-overflow" />
                  </div>
                  <div className="demographic-float-right">
                    <img
                      className="i360_header_icons_img size-lg"
                      src={clearFilterIcon}
                      alt="Remove"
                      onClick={() => {
                        this.handleRemovePersonaCreatorClick();
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="demographic-header-border creatorHeaderLabelFlag">
                <div className="padding-left-15 padding-bottom-10">
                  PERCENTAGE VARIANCE EXPLAINED{' '}
                  {this.state.PersonaCreatorheaderVariance == null
                    ? ''
                    : ` ${this.state.PersonaCreatorheaderVariance} %`}
                  {this.state.PersonaCreatorheaderVariance !== null &&
                    this.state.PersonaCreatorheaderVariance !== undefined &&
                    this.state.PersonaCreatorheaderVariance !== '' && (<img
                      alt="info_icon"
                      className="i360_header_icons_img size-sm"
                      src={infoIconWhite}
                      title={INSIGHT_360_CREATOR_VARIANCE_INFO}
                    />
                    )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

PersonaCreatorHeader.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({}),
  }),
  pcheaderData: PropTypes.shape({
    weighted: PropTypes.number,
    pct: PropTypes.number,
    label: PropTypes.string,
    sample: PropTypes.number,
  }),
  removePersonaCreator: PropTypes.func,
  segments: PropTypes.shape({
    segments: PropTypes.string,
    defId: PropTypes.string,
    variance: PropTypes.number,
  }),
  savePersonaCreatorDefLabel: PropTypes.func,
  insight360study: PropTypes.shape({
    productId: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    pcheaderData: state.insight360.personaCreator.header,
    segments: state.insight360.personaCreator.segments,
    insight360study: state.study.insight360study,
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true },
)(PersonaCreatorHeader);
